import { Show, EditButton } from '@refinedev/antd'
import { useShow } from '@refinedev/core'
import { Descriptions, Image, Space, Tag, Typography, Table, Card, Rate } from 'antd'

const { Paragraph } = Typography

interface SpecRow {
  name: string
  amount?: string
  nrv?: string
}

export default function ProductShowPage() {
  const { query } = useShow()
  const record = query?.data?.data as any
  const isLoading = query?.isLoading

  const fmtPrice = (v?: number) =>
    v == null ? '—' : `${Number(v).toLocaleString('sr-RS')} ${record?.currency ?? 'RSD'}`

  return (
    <Show
      isLoading={isLoading}
      headerButtons={<EditButton>Izmeni</EditButton>}
      title={record?.name}
    >
      {record && (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          {record.images?.length > 0 && (
            <Space wrap>
              {record.images.map((url: string) => (
                <Image key={url} src={url} width={120} height={120} style={{ objectFit: 'cover', borderRadius: 8 }} />
              ))}
            </Space>
          )}

          <Descriptions bordered column={2} size="small">
            <Descriptions.Item label="Naziv">{record.name}</Descriptions.Item>
            <Descriptions.Item label="Slug">{record.slug}</Descriptions.Item>
            <Descriptions.Item label="Kategorija">{record.category?.name ?? '—'}</Descriptions.Item>
            <Descriptions.Item label="Oznaka">
              {record.badge ? <Tag color="magenta">{record.badge}</Tag> : '—'}
            </Descriptions.Item>
            <Descriptions.Item label="Cena">{fmtPrice(record.price)}</Descriptions.Item>
            <Descriptions.Item label="Stara cena">{fmtPrice(record.compareAtPrice)}</Descriptions.Item>
            <Descriptions.Item label="Pretplata">
              {record.subscriptionEnabled
                ? `${fmtPrice(record.subscriptionPrice)} / mesec (-${record.subscriptionDiscountPct ?? 0}%)`
                : 'Ne'}
            </Descriptions.Item>
            <Descriptions.Item label="Zalihe">
              {record.stockStatus === 'IN_STOCK' ? <Tag color="green">Na stanju</Tag> : <Tag color="red">Nema</Tag>}
              {record.stock != null ? ` (${record.stock})` : ''}
            </Descriptions.Item>
            <Descriptions.Item label="Aktivan">
              {record.active ? <Tag color="green">Da</Tag> : <Tag>Ne</Tag>}
            </Descriptions.Item>
            <Descriptions.Item label="Ocena">
              {record.ratingCount > 0 ? (
                <span>
                  <Rate disabled allowHalf value={Number(record.ratingAvg) || 0} /> ({record.ratingCount})
                </span>
              ) : (
                'Nema ocena'
              )}
            </Descriptions.Item>
          </Descriptions>

          {record.shortDescription && <Paragraph strong>{record.shortDescription}</Paragraph>}
          {record.description && <Paragraph>{record.description}</Paragraph>}

          {record.certifications?.length > 0 && (
            <Space wrap>
              {record.certifications.map((c: string) => (
                <Tag key={c}>{c}</Tag>
              ))}
            </Space>
          )}

          {record.specs?.length > 0 && (
            <Card size="small" title="Sastav">
              <Table<SpecRow>
                dataSource={record.specs}
                rowKey="name"
                pagination={false}
                size="small"
                columns={[
                  { title: 'Sastojak', dataIndex: 'name' },
                  { title: 'Količina', dataIndex: 'amount' },
                  { title: '%NRV', dataIndex: 'nrv' },
                ]}
              />
            </Card>
          )}

          {record.usage && (record.usage.dose || record.usage.administration || record.usage.notes) && (
            <Card size="small" title="Upotreba">
              <Descriptions column={1} size="small">
                {record.usage.dose && <Descriptions.Item label="Doza">{record.usage.dose}</Descriptions.Item>}
                {record.usage.administration && (
                  <Descriptions.Item label="Primena">{record.usage.administration}</Descriptions.Item>
                )}
                {record.usage.notes && <Descriptions.Item label="Napomena">{record.usage.notes}</Descriptions.Item>}
              </Descriptions>
            </Card>
          )}
        </Space>
      )}
    </Show>
  )
}
